
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbRelatorioChamadas extends AppService {
  abstract getRelatorioChamadas(filter: String): Observable<any>;
  abstract getRelatorio(filter: string): Observable<any>;
  abstract getAllRelatorioRamais(): Observable<any>;
  abstract getAllRelatorioDispositivo(): Observable<any>;

}